import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import { mediaSrc } from "@/lib/media";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export { mediaSrc } from "@/lib/media";

export const ImageUpload = ({ value, onChange, folder = "covers", label = "Cover photo", testid = "image-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const body = new FormData();
    body.append("file", file);
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/uploads/image?folder=${folder}`, body, {
        withCredentials: true,
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div data-testid={testid} className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">{label}</div>
      <div className="flex items-center gap-3">
        <div className="h-16 w-28 shrink-0 rounded-xl overflow-hidden border border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-white/5 grid place-items-center">
          {value ? (
            <img data-testid={`${testid}-preview`} src={mediaSrc(value)} alt="Cover" className="h-full w-full object-cover" />
          ) : (
            <ImagePlus className="h-4 w-4 text-slate-400" />
          )}
        </div>
        <div className="flex flex-col gap-1.5">
          <button
            type="button"
            onClick={() => ref.current?.click()}
            disabled={busy}
            data-testid={`${testid}-btn`}
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 dark:border-white/10 px-3.5 py-2 text-[11px] font-semibold hover:border-[#06B6D4]/60 transition-colors disabled:opacity-50"
          >
            <ImagePlus className="h-3 w-3" /> {busy ? "Uploading…" : value ? "Replace photo" : "Upload photo"}
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              data-testid={`${testid}-remove`}
              className="inline-flex items-center gap-1.5 text-[11px] text-slate-500 hover:text-rose-500 transition-colors"
            >
              <Trash2 className="h-3 w-3" /> Remove
            </button>
          )}
        </div>
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" onChange={pick} className="hidden" />
    </div>
  );
};
